import { render, staticRenderFns } from "./projectTypeManager.vue?vue&type=template&id=df3f672e&"
import script from "./projectTypeManager.vue?vue&type=script&lang=js&"
export * from "./projectTypeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports